module.exports = __webpack_public_path__ + "img/monde.6108afc0.png";